"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadContentSections = exports.getFirstContentSectionForType = exports.getFirstContentSectionForTypes = exports.combineResults = exports.parseIncludesForItem = exports.getIncludesOfType = exports.getImageReference = exports.getItemReference = exports.filterListForType = void 0;
const types_1 = require("./types");
function filterListForType(list, type) {
    return list.filter((x) => x.sys.contentType.sys.id === type);
}
exports.filterListForType = filterListForType;
function getItemReference(itemReference, includeList) {
    var _a;
    if (!itemReference) {
        return null;
    }
    if (itemReference.fields) {
        return itemReference;
    }
    const item = (_a = includeList === null || includeList === void 0 ? void 0 : includeList.Entry) === null || _a === void 0 ? void 0 : _a.find((entry) => entry.sys.id === itemReference.sys.id);
    return item || null;
}
exports.getItemReference = getItemReference;
function getImageReference(imageReference, includeList) {
    var _a;
    if (!imageReference) {
        return null;
    }
    if (imageReference.fields) {
        return imageReference;
    }
    const item = (_a = includeList === null || includeList === void 0 ? void 0 : includeList.Asset) === null || _a === void 0 ? void 0 : _a.find((asset) => asset.sys.id === imageReference.sys.id);
    return item || null;
}
exports.getImageReference = getImageReference;
function getIncludesOfType(includeList, contentType) {
    if (!includeList || !includeList.Entry) {
        return [];
    }
    return includeList.Entry.filter((entry) => entry.sys.contentType.sys.id === contentType);
}
exports.getIncludesOfType = getIncludesOfType;
function parseIncludesForItem(includeList, itemId) {
    var _a, _b;
    return (((_a = includeList === null || includeList === void 0 ? void 0 : includeList.Entry) === null || _a === void 0 ? void 0 : _a.find((entry) => entry.sys.id === itemId)) ||
        ((_b = includeList === null || includeList === void 0 ? void 0 : includeList.Asset) === null || _b === void 0 ? void 0 : _b.find((asset) => asset.sys.id === itemId)));
}
exports.parseIncludesForItem = parseIncludesForItem;
function combineResults(results) {
    return results.reduce((combined, result) => {
        if (result.items.length > 0) {
            combined.items = combined.items
                .concat(result.items)
                .reduce((resultItems, resultItem) => {
                let exists = !!resultItems.find((x) => x.sys.id === resultItem.sys.id);
                if (!exists) {
                    resultItems.push(resultItem);
                }
                return resultItems;
            }, []);
            combined.includes = {
                Asset: combined.includes.Asset.concat(result.includes.Asset),
                Entry: combined.includes.Entry.concat(result.includes.Entry),
            };
            combined.total = combined.total + result.total;
        }
        return combined;
    }, {
        items: [],
        includes: { Asset: [], Entry: [] },
        total: 0,
        skip: 0,
        limit: 0,
        stringifySafe: () => "",
        toPlainObject: () => Object.assign({}),
    });
}
exports.combineResults = combineResults;
const getFirstContentSectionForTypes = (keys, content) => {
    return keys.map((key) => (0, exports.getFirstContentSectionForType)(key, content));
};
exports.getFirstContentSectionForTypes = getFirstContentSectionForTypes;
const getFirstContentSectionForType = (key, content) => {
    var _a;
    return (_a = content.mapped[key]) === null || _a === void 0 ? void 0 : _a.contentSections[0];
};
exports.getFirstContentSectionForType = getFirstContentSectionForType;
const loadContentSections = async (client, pageSections) => {
    var _a;
    const sectionsAndIds = pageSections.map((x) => {
        var _a, _b;
        return {
            id: x.sys.id,
            pageSection: x,
            contentIds: (_b = (_a = x.fields.content) === null || _a === void 0 ? void 0 : _a.map((content) => content.sys.id)) !== null && _b !== void 0 ? _b : [],
        };
    });
    const allContentSections = await client.getEntries({
        content_type: types_1.ContentfulContentType.PageContentSection,
        ["sys.id[in]"]: sectionsAndIds.map((x) => x.contentIds.join(",")).join(","),
    });
    return {
        sections: sectionsAndIds.reduce((total, section) => {
            return {
                ...total,
                [section.id]: section.contentIds.map((x) => allContentSections.items.find((content) => content.sys.id === x)),
            };
        }, {}),
        includes: (_a = allContentSections.includes) !== null && _a !== void 0 ? _a : null,
        mapped: sectionsAndIds.reduce((total, section) => {
            return {
                ...total,
                [section.pageSection.fields.sectionKey]: {
                    pageSection: section.pageSection,
                    contentSections: section.contentIds.map((x) => allContentSections.items.find((content) => content.sys.id === x)),
                },
            };
        }, {}),
    };
};
exports.loadContentSections = loadContentSections;
//# sourceMappingURL=helpers.js.map